import React, {ChangeEvent, useState} from "react";
import {DraggableData, DraggableEvent} from "react-draggable";
import {useForceUpdate, useStyle, useWindowStyle} from "../../../hooks";
import FancyWindow, {FancyWindowProps} from "../dialogs/FancyWindow";
import {InputBase} from "@mui/material";
import {ExecutableNodeType, NodeType} from "../../../common/types/nodeTypes";
import store, {useTypedSelector} from "../../../store";
import {setConnectionLine} from "../../../store/nodes";
import {getNodeTypes} from "../../../common/machine/MachineHandler";
import {ExecutableNodeTypeListScroller, TypedNodeFilter} from "./ExecutableNodeTypeListScroller";

const NodeSearch = ({position, onClose, onSelect, disableClickAway, ...props}: {
    position: number[],
    onClose?: () => any,
    onSelect?: (type: NodeType, name: string, pckg: string) => any,
    disableClickAway?: boolean,
    filter?: TypedNodeFilter
}) => {
    const [disposed, setDisposed] = useState<boolean>(false);
    const connectionLine = useTypedSelector(state => state.nodes.connectionLine);

    const update = useForceUpdate();

    const handleDisposeTyper = () => {
        setDisposed(true);
        onClose && onClose();
    }
    const handleClickAway = () => {
        if (!disableClickAway) handleDisposeTyper();
    }
    const handleTyperBlur = () => {
        if (!store.getState().nodes.connectionLine) {
            handleDisposeTyper();
        }
    }
    const handleSelect = (type: ExecutableNodeType, key: string, pckg: string) => {
        setDisposed(true);
        onSelect && onSelect(type, key, pckg);
    }
    const [value, setValue] = useState<string>("");
    const [delta, setDelta] = useState<number[]>([0, 0]);
    const [filter, setFilter] = useState<TypedNodeFilter | undefined>(props.filter);

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => setValue(e.target.value)
    const handleDrag = (e: DraggableEvent, {deltaX, deltaY}: DraggableData) => setDelta(d => {
        d[0] += deltaX;
        d[1] += deltaY;
        return [...d];
    });

    const style = useStyle();
    const windowStyle = useWindowStyle();

    const typerDialogStyle: FancyWindowProps = {
        shadowColor: style.shadow.color,
        callback: handleDisposeTyper,
        resizable: true,
        header: false
    }

    return <>
        {/*<ClickAway onClick={handleClickAway} disabled/>*/}
        {position && (value.length > 2 || (filter && (filter.input || filter.output))) && <FancyWindow
            {...typerDialogStyle}
            x={position[0] - (windowStyle.window?.windowControlBarPadding ?? 0) - 3}
            y={position[1] - (windowStyle.window?.windowControlBarPadding ?? 0) - 12}
            width={360}
            onDrag={handleDrag}
            hollow
            paddingTop={2}
        >
            {disposed && <div style={{
                position: 'absolute',
                left: (windowStyle.window?.windowControlBarPadding ?? 0) + 3,
                top: (windowStyle.window?.windowControlBarPadding ?? 0) - 21
            }}>
                <div style={{
                    transform: 'translateY(-50%)',
                    border: 0,
                    background: 'transparent', //'#00204020',
                    //width: 'auto',
                    fontFamily: 'Roboto Mono',
                    fontSize: 14,
                    fontWeight: 400,
                    lineHeight: '14px',
                    color: style.components.Input.color
                }}>
                    {value}
                </div>
            </div>}
            <ExecutableNodeTypeListScroller
                types={getNodeTypes()}
                filter={{query: value, input: filter?.input, output: filter?.output}}
                onSelectItem={handleSelect}
                style={{position: "absolute", minHeight: 248 + 14, height: 'calc(100% - 18px)', marginTop: 48 - 14, paddingBottom: 8}}
            />
            {connectionLine && <div
                style={{
                    position: 'absolute',
                    left: 0,
                    top: -32,
                    right: 0,
                    bottom: 0,
                    background: '#ff000020',
                    zIndex: 9999,
                    pointerEvents: 'auto'
                }}
                onMouseUp={() => {
                    setFilter(f => f && {...f, input: f.input ? [...f.input, []] : [[]]});
                    store.dispatch(setConnectionLine(undefined));
                    update();
                }}
            />}
        </FancyWindow>}
        {position && !disposed && <div style={{
            position: 'absolute',
            left: position[0] + delta[0],
            top: position[1] + delta[1],
            zIndex: 9999
        }}><InputBase
            style={{
                transform: 'translateY(-50%)',
                border: 0,
                background: 'transparent', //'#00204020',
                //width: 'auto',
                fontFamily: 'Roboto Mono',
                fontSize: 14,
                fontWeight: 400,
                lineHeight: '14px',
                color: style.components.Input.color,
                width: (value.length + 1) + 'ch'
            }}
            type="text"
            value={value}
            onChange={handleChange}
            onBlur={handleTyperBlur}
            onKeyDown={e => e.key === 'Escape' && handleDisposeTyper()}
            autoFocus
        /></div>}
    </>
}

export default NodeSearch;